import { Grid, InputAdornment, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';
import MailIcon from '@material-ui/icons/Mail';
import { bankInformationPropertyStates, isNotBlank } from '@roc/feature-utils';
import {
  createNumberFormatField,
  createPhoneField,
  createTextField,
  SelectField,
  Tooltip,
} from '@roc/ui';
import { observer } from 'mobx-react';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    fontSize: '18px',
    marginLeft: '5px',
    marginBottom: '2px',
  },
}));

export const VerifyBankInformationForm = observer(({ store }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">
          Account Details
          <Tooltip title="Please verify the account details to ensure accuracy before submitting">
            <HelpIcon className={classes.icon} fontSize="small" />
          </Tooltip>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Account Name/Title',
          fieldName: 'accountName',
          testId: 'accountName',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          label: 'ABA (FedWire) Routing Number',
          fieldName: 'routingNumber',
          format: '#########',
          testId: 'routingNumber',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          label: 'Account Number',
          fieldName: 'accountNumber',
          testId: 'accountNumber',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Bank Name',
          fieldName: 'bankName',
          testId: 'bankName',
          store,
        })}
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h5">Contact Information</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Full Name',
          fieldName: 'fullName',
          testId: 'fullName',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createPhoneField({
          label: 'Phone Number',
          fieldName: 'phoneNumber',
          testId: 'phoneNumber',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Email',
          fieldName: 'emailAddress',
          testId: 'emailAddress',
          type: 'email',
          store,
          InputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <MailIcon />
              </InputAdornment>
            ),
          },
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Street Name',
          fieldName: 'streetName',
          testId: 'streetName',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'City',
          fieldName: 'city',
          testId: 'city',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Zip Code',
          fieldName: 'zipCode',
          testId: 'zipCode',
          store,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          standaloneLabel
          label={'State'}
          name={'state'}
          value={store.form.fields.state.value}
          error={isNotBlank(store.form.fields.state.error)}
          errorText={store.form.fields.state.error}
          options={bankInformationPropertyStates}
          onChange={label => store.onFieldChange('state', label)}
          variant="outlined"
          fullWidth
          shrink
          required
          testId="state"
        />
      </Grid>
    </Grid>
  );
});
